import { useCases } from "@repo/data-store";
import { createFileRoute } from "@tanstack/react-router";
import { CaseList } from "@/features/cases";

export const Route = createFileRoute("/patients/$patientId/_layout/cases/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { patientId } = Route.useParams();
  const cases = useCases({ patientId });

  if (cases.length === 0) {
    return <CaseList.Empty />;
  }

  return (
    <CaseList>
      <CaseList.Body>
        {cases.map((c) => (
          <CaseList.Item key={c.caseId} case={c} patientId={patientId} />
        ))}
      </CaseList.Body>
    </CaseList>
  );
}
